import React from "react";

import {
  Edit,
  SimpleForm,
  ReferenceField,
  TextField,
  Toolbar,
  SaveButton,
  Labeled,
} from "react-admin";
import { CustomDateTimeInput } from "../lib/datetime";
import { AliasOrBarcodeReference } from "../lib/aliasWithBarcodeTooltip";

const LotVesselEditToolbar = (props) => (
  <Toolbar {...props}>
    <SaveButton />
  </Toolbar>
);

export const LotVesselEdit = (
  <Edit redirect={false}>
    <SimpleForm toolbar={<LotVesselEditToolbar />}>
      <Labeled label="ID">
        <TextField source="id" />
      </Labeled>
      <Labeled label="Associated Lot">
        <ReferenceField source="lotID" reference="lots" link="show">
          <TextField label="Lot" source="name" />
        </ReferenceField>
      </Labeled>
      <Labeled label="Associated Vessel">
        <AliasOrBarcodeReference
          source="barrelID"
          reference="vessels"
          label="Associated Vessel"
        />
      </Labeled>

      <CustomDateTimeInput source="startTime" label="Start Time" />
      <CustomDateTimeInput source="endTime" label="End Time" />
    </SimpleForm>
  </Edit>
);
